import { defineMessages } from 'react-intl'

export default defineMessages({
  locationFindLocationPlaceholder: {
    id: 'app.location.findLocationPlaceholder',
    defaultMessage: 'Find location',
  },
  locationHeadline: {
    id: 'app.location.headline',
    defaultMessage: 'Location',
  },
  locationNotFound: {
    id: 'app.location.notFound',
    defaultMessage: 'Location not found',
  },
  otherPlaceHolderComments: {
    id: 'app.other.placeholderComments',
    defaultMessage: 'Comments',
  },
  otherValidationComments: {
    id: 'app.other.validationComments',
    defaultMessage: 'Comment is required!',
  },
  otherFieldLabel: {
    id: 'app.other.fieldLabel',
    defaultMessage: 'What do you want to change?',
  },
  changePolicyOtherThankYouTitle: {
    id: 'app.changePolicy.other.thankYouTitle',
    defaultMessage: 'Thank you',
  },
  changePolicyOtherSuccessMsg: {
    id: 'app.changePolicy.other.success',
    defaultMessage: 'Successfully added a comment to your policy.',
  },
  changePolicyNotificationSuccess: {
    id: 'app.changePolicy.notification.success',
    defaultMessage: 'Your change request has been successfully sent.',
  },
})
